import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import * as React from "react";
import { Button, CreateButton } from "react-admin";
import { IconButton } from "../icon-button/IconButton.tsx";
import AddIcon from "@mui/icons-material/Add";


interface EmptyBoxProps {
    title: string;
    resource?: string;
    onClick?: () => void;
    description?: string;
}
export const EmptyBox: React.FC<EmptyBoxProps> = ({ title, description, resource, onClick }) => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="300px"
            textAlign="center"
            gap={2}
        >
            <Box>
                <Typography variant="h6" color="text.secondary" gutterBottom
                    sx={{
                        fontSize: 'var(--text-xl)',
                    }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary"
                    sx={{
                        fontSize: 'var(--text-xs)',
                    }}>
                    {description}
                </Typography>
            </Box>
            {!onClick ?
                <CreateButton
                    label={t('ra.action.create')}
                    resource={resource || ''}
                    sx={{
                        color: 'var(--color-primary)',
                        fontWeight: 700,
                        fontSize: '16px',
                        backgroundColor: 'transparent',
                        padding: '0',
                        minWidth: '30px',
                        '& .MuiButton-startIcon': { marginRight: 'var(--space-6)' },
                    }}
                />
                :
                <IconButton
                    label={t('common.create')}
                    icon={<AddIcon />}
                    sx={{
                        fontSize: 'var(--text-xs)',
                        backgroundColor: 'transparent',
                        color: 'var(--color-primary)',
                        fontWeight: 700,

                    }}
                    onClick={onClick} />
            }
        </Box>
    );
};